import { useState } from 'react';
import type { FaqItem } from './data';

export default function FaqAccordion({ faqs }: { faqs: FaqItem[] }) {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggle = (i: number) => setActiveIndex(activeIndex === i ? -1 : i);

    return (
        <div className="bg-white rounded-2xl lg:rounded-3xl">
            <h2 className="p-2.5 text-2xl font-bold leading-[1.3] tracking-[-0.5px] text-foreground sm:text-[28px] lg:text-[36px]">
                FAQ
            </h2>
            {faqs.map((faq, i) => {
                const isOpen = activeIndex === i;
                return (
                    <div key={i} className={i > 0 ? 'border-t border-gray-100' : ''}>
                        <button
                            type="button"
                            className="flex items-center gap-4 lg:gap-8 w-full px-5 lg:px-10 py-5 lg:py-6 text-left cursor-pointer"
                            onClick={() => toggle(i)}
                        >
                            {/* Number */}
                            <span
                                className={`text-base sm:text-lg lg:text-xl font-extrabold min-w-8 sm:min-w-9 lg:min-w-11 transition-colors duration-300 ${
                                    isOpen ? 'text-primary' : 'text-foreground'
                                }`}
                            >
                                {String(i + 1).padStart(2, '0')}.
                            </span>

                            {/* Question */}
                            <span className="flex-1 text-sm sm:text-base lg:text-lg font-bold text-foreground leading-snug">
                                {faq.question}
                            </span>

                            {/* +/- Icon */}
                            <span className="relative w-5 h-5 flex items-center justify-center shrink-0">
                                <span className="absolute w-3.5 h-0.5 bg-foreground rounded-full" />
                                <span
                                    className={`absolute w-3.5 h-0.5 bg-foreground rounded-full transition-transform duration-300 ${
                                        isOpen ? '' : 'rotate-90'
                                    }`}
                                />
                            </span>
                        </button>

                        {/* Answer */}
                        <div className={`grid ${isOpen ? 'faq-row-open' : 'faq-row-closed'}`}>
                            <div className="overflow-hidden">
                                <p className="text-text-light text-xs leading-relaxed px-5 pb-5 pl-12 pr-8 sm:text-sm sm:pl-14 lg:px-10 lg:pb-6 lg:pl-27 lg:pr-20">
                                    {faq.answer}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
